import { render } from "./modal.vue?vue&type=template&id=6fed558e"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/crud-projects/crederi-all/crederi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__